import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/calvary-building-services/calvary-building-services/components/ConfigImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/calvary-building-services/calvary-building-services/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/calvary-building-services/calvary-building-services/components/StatsRow.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/calvary-building-services/calvary-building-services/node_modules/next/dist/client/app-dir/link.js");
